<template>
  <div class="selfPriceTable">
    <el-form ref="formTool" :inline="true" style="text-align: left">
      <el-table v-loading="loading" :span-method="({ row, column, rowIndex, columnIndex }) =>
        objectSpanMethod({ row, column, rowIndex, columnIndex }, areaData)
        " :data="areaData" style="width: 100%">
        <el-table-column label="省级组织" width="140px" fixed >
          <template slot-scope="scope">
           <div style="text-align: center;margin-bottom: 10px;">
            <span  >{{provinceOrgName}}</span> 
           </div> 
          </template>
        </el-table-column> 
        <el-table-column label="地级组织" prop="orgName" width="180" fixed>
        </el-table-column>
        <el-table-column label="所属医药公司" prop="shopName" idth="220" fixed>
        </el-table-column>
        <el-table-column label="统一分账规则使用" prop="" width="140">
          <template slot-scope="scope">
            <!-- {{ scope.row.isEdit || '' }} -->
            <div class="status_img" v-if="scope.row.goodsSkuPriceId && scope.row.status == 'PUTAWAY' ">
              <img src="@/assets/success.png" alt="" />
            </div>
            <div class="status_img" v-if="!scope.row.goodsSkuPriceId || scope.row.status != 'PUTAWAY'">
              <img src="@/assets/reject.png" alt="" />
            </div>
          </template>
        </el-table-column> 
       
        <el-table-column label="医药公司康贝" prop="merchantNo" width="200">
          <template slot-scope="scope">
           
            <el-select
            size="mini"
            :disabled="true"
            v-model="scope.row.merchantNo"  
          >
                <el-option
                v-for="(item,key) in listByShopId"
                :key="key"
                :label="item.merchantNo"
                :value="item.merchantNo"> 
                <span style=" color: #8492a6; font-size: 13px">康贝号:  {{ item.merchantNo }}</span>
                <span  > {{ item.merchantName }}</span>
                <!-- <span  > 结算金额: {{ item.money }}</span>   -->
              </el-option>
            </el-select>

          </template>
        </el-table-column>
    
        <el-table-column label="地区公司名称" prop="city_shopName" width="200">
          <template slot-scope="scope">
            <el-select size="mini" clearable v-model="scope.row.city_shopName"
              :disabled="true" >
              <el-option v-for="item in cityManager" :key="item.shopId" :label="item.shopName" :value="item" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="地区公司康贝" prop="city_merchantNo" width="200">
          <template slot-scope="scope">
            <el-select
              size="mini"
              :disabled="true"
              v-model="scope.row.city_merchantNo"
              @visible-change="
              (val) => {
                getListByShopIdFn(val, scope.row.city_shopId,2);
                  }
              "
            >
            <el-option
            v-for="(item,key) in listByShopId2"
            :key="key"
            :label="item.merchantNo"
            :value="item.merchantNo"> 
            <span style=" color: #8492a6; font-size: 13px"> 康贝号: {{ item.merchantNo }}</span>
            <span  >  {{ item.merchantName }}</span>
            
          </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="地区公司划转" prop="dbTransferAmount" width="140">
          <template slot-scope="scope">
            <div class="unit-box">
              <!-- <span class="unit-input-s" v-if="scope.row.dbTransferAmount" :style="
                (!scope.row.isEdit)
                ? 'color:#8c8c8c'
                : 'color:#606266'
                ">¥</span> -->
             
                <!-- 根据 统一分账规则使用 判断 地区公司划转是否禁填 -->
              <span>
                <el-input 
                  :disabled=" (!scope.row.isEdit)
                  ? true
                  : false
                  " v-model="scope.row.dbTransferAmount" style="width: 100px" size="mini"
                  oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''">
                  <template slot="prefix">
                    <span class="unitY"  :style=" (!scope.row.isEdit)
                    ? 'color:#8c8c8c'
                    : 'color:#606266'
                    ">￥</span> 
                  </template>
                </el-input></span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="省区公司名称" prop="serviceMerchantNo" width="200">
          <template slot-scope="scope">
            <el-select size="mini" :disabled="true"
              v-model="scope.row.serviceShopName"  >
              <el-option v-for="item in provinceManager" :key="item.shopId" :label="item.shopName" :value="item" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="省区公司康贝" prop="serviceMerchantNo" width="200">
          <template slot-scope="scope">
             
            <el-select
              size="mini"
              :disabled="true"
              v-model="scope.row.serviceMerchantNo" 
            >
            <el-option
            v-for="(item,key) in listByShopId3"
            :key="key"
            :label="item.merchantNo"
            :value="item.merchantNo"> 
            <span style=" color: #8492a6; font-size: 13px"> 康贝号: {{ item.merchantNo }}</span>
            <span  >  {{ item.merchantName }}</span> 
          </el-option>
            </el-select>
          </template>
        </el-table-column>
         <!-- 根据 统一分账规则使用 判断 地区公司划转是否禁填 --> 
        <el-table-column label="省区公司划转" prop="sbTransferAmount" minWidth="240">
          <template slot-scope="scope">
            <div class="unit-box">
              <!-- <span class="unit-input-s" v-if="scope.row.sbTransferAmount" :style=" (!scope.row.isEdit)
                ? 'color:#8c8c8c'
                : 'color:#606266'
                ">¥</span> -->
              <!-- <span class="unit-input-b" v-if="!scope.row.serviceAmount"></span> -->
              <span>
                <el-input :disabled=" (!scope.row.isEdit) ? true : false" v-model="scope.row.sbTransferAmount"
                
                  style="width: 100px" size="mini"
                  oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''">
                  <template slot="prefix"
                  >
                    <span class="unitY"  :style=" (!scope.row.isEdit)
                    ? 'color:#8c8c8c'
                    : 'color:#606266'
                    ">￥</span> 
                  </template>
                </el-input></span>
              <span v-if="!scope.row.city_shopName" style="margin-left: 10px;">
                省区公司直管
              </span>
            </div> 
          </template>
        </el-table-column> 

        <el-table-column label="云药库划转" prop="yykTransferAmount" minWidth="240">
          <template slot-scope="scope">
            <div class="unit-box"> 
              <span>
                <el-input :disabled=" (!scope.row.isEdit) ? true : false" v-model="scope.row.yykTransferAmount"
                
                  style="width: 100px" size="mini"
                  oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''">
                  <template slot="prefix"
                  >
                    <span class="unitY"  :style=" (!scope.row.isEdit)
                    ? 'color:#8c8c8c'
                    : 'color:#606266'
                    ">￥</span> 
                  </template>
                </el-input></span>
               
            </div> 
          </template>
        </el-table-column> 
      </el-table>
    </el-form>
  
  </div>
</template>

<script>
import {
  getAreaCompany,
  productLineAreaPricesSelfBatch,
  getSelfPriceAndLedgerRule,
  skuUpdateStatus,
  getProductLineSkuList,
  getListByShopId
} from "@/api/saleRule/productLine";

import {getStandbySaleRuleOpenTips,setStandbyEnable,setStandbyRule} from "@/api/product"


const dataLine = {
  productLineId: "",
  ledgerRulesId: "",
  shopId: "",
  shopName: "",
  price: "",
  amount: "",
  merchantNo: "", //医药公司 康贝号
  city_shopId: "",
  city_shopName: "",
  city_amount: "",
  city_merchantNo: "", //地区公司 康贝号
  city_ledgerRulesId: "",
  city_id: "",
  drug_ledgerRulesId: "",
  drug_id: "",
  serviceShopId: "",
  serviceShopName: "",
  serviceAmount: "",
  serviceMerchantNo: "", //省区公司 康贝号
  goodsSkuUnit: "盒",
  dbTransferAmount:null,
  sbTransferAmount:null,
  yykTransferAmount:null,
  // provinceOrgName: this.provinceOrgName,
  // provinceOrgCode: this.provinceOrgCode,
  orgCode: "",
  orgName: "",
  status: "SOLDOUT", //@Schema(description = "状态：PUTAWAY.上架,SOLDOUT.下架")
};
export default {
  props: {
    goodsId: {
      type: String,
      default() {
        return null;
      },
    },
    goodsName: {
      type: String,
      default() {
        return "";
      },
    },
    dfcData: {
      type: Array,
      default() {
        return [];
      },
    }, // 列表数据
    unitList: {
      type: Array,
      default() {
        return [];
      },
    }, // 单位数据
  },
  data() {
    return {
      kbSwitchFlag:0,  //康贝分流开关:0分流1不分流（指定账户）
      formTool: {},
      loading: false,
      dialogVisible: false,
      provinceOrgCode: "", // 省办orgCode /取的weight字段
      provinceOrgName: "湖南",
      areaListArr: [],
      areaData: [],
      medicineManager: [],
      cityManager: [],
      provinceManager: [],
      goodsSkuUnit: "盒",
      unitKey: 0,
      companyList: [], //医药公司名称
      orgCodeList: [], //区域code集合
      deatilData: [], //详情数据
      listByShopId: [],
      listByShopId2: [], //地区公司康贝
      listByShopId3: [], //省区区公司康贝
      dbTransferAmount:null,
      sbTransferAmount:null,
      yykTransferAmount:null
    };
  },
  created() { },
  //   @Schema(description = "状态：PUTAWAY.上架,SOLDOUT.下架")   // private String status;

  methods: {
    changeSwitch(e){ 
      let parmas = {};
      parmas.goodsId = this.goodsId; 
      parmas.orgCodeSet = this.orgCodeList; 
      // 开启的提醒弹窗 
      getStandbySaleRuleOpenTips(parmas).then((res)=>{ 
        // 开启弹窗，需要提醒 弹窗提醒，否则正常开启
        if(res.msg =='success' && !res.data){ 
          this.submit('open',e)
        }else{ 
          if(e==1) {
              this.$confirm(res.data, '开启提醒', {
                confirmButtonText: '确定',
                cancelButtonText: '返回',
                type: 'warning'
              }).then(() => { 
                // 调用开启关闭接口 开启
                this.submit('open',e) 
              }).catch((status) => { 
                if(status == 'cancel') { 
                  console.log(status)
                    if(e==1){
                      this.$parent.standbyEnable = 0 
                    }
                    if(e==0){
                      this.$parent.standbyEnable = 1 
                    }
                  } 
              });
          }else{
              // 调用开启关闭接口 
            this.submit('open',e)  
          }
         
        } 
      }) 
    },

    // 开启备用分账
    // setStandbyEnable
    openStandByLedger(e,arr){
      let params ={};
      params.ledgerRulesIds =[];
      params.enable = e; 
      for (let item of arr) { 
        // console.log(item,'--item') 
        if(item.city_ledgerRulesId){ 
         params.ledgerRulesIds.push(item.city_ledgerRulesId) 
        } 
      } 
      // console.log(params,'---params')
      setStandbyEnable(params).then((res)=>{
        if(res.msg=='sucess'){
          this.$message.success('开启成功') 
        }
      }).catch((err)=>{})
    },

    // 根据店铺获取已有康贝号列表
    getListByShopIdFn(val, shopId, type) {
      console.log(shopId)
      if (!shopId) {
        console.log('shopId获取失败！')
        // this.$message.error('shopId获取失败！')
        return
      }
      let params = {
        shopId: shopId
      };
      getListByShopId(params).then((res) => {
        if (res) {
          if (type == 1) {
            this.listByShopId = res;
          }
          if (type == 2) {
            this.listByShopId2 = res;
          }
          if (type == 3) {
            this.listByShopId3 = res;
          }
        }
      });
    },
    init(provinceOrgName) {
      if (provinceOrgName) {
        this.provinceOrgName = provinceOrgName;
        this.initAreaData();
      } else {
        this.initAreaData();
      }
    },
    // // 初始化省市区域数据

    initAreaData() {
      this.orgCodeList = [];
      this.areaList = this.dfcData; // 区域list 换成组织list 
      // 1取出对应省办 地办数据
      this.areaListArr = [];
      this.areaList.map((item) => {
        if (item.name == this.provinceOrgName) {
          this.provinceOrgCode = item.weight;
          this.areaListArr = item.children || [];
        }
      });

      // 2市区级数据 orgCodeList
      this.areaListArr.map((item) => {
        this.orgCodeList.push(item.weight);
      });
      this.orgCodeList.push(this.provinceOrgCode);
      this.getAreaCompanyFn(); // 统一分账获取省地办
    },

    // 有sku才可以上架
    initData() {
      // 区域list // 初始化省市区 表格内显示的静态数据  
      this.getProductLineSkuList(); 
      this.loading = false;
    },

    // 获取 商品skulist
    getProductLineSkuList(shopId, type, index) {
      let params = {
        goodsId: this.goodsId, //必传
        // shopId: shopId, //必传
        orgCodeSet: this.orgCodeList, //必传
      };
      getProductLineSkuList(params)
        .then((res) => {
          let resp = res;
         
          let areaData = [];

          // 初始默认的市区地域列表
          this.areaListArr.map((k) => {
            let newData = { ...dataLine};
            newData.orgCode = k.weight;
            newData.orgName = k.name;
            newData.provinceOrgName =this.provinceOrgName;
            areaData.push(newData)
          });
            let szObj = { ...dataLine };
            szObj.orgName = "省直";
            szObj.orgCode = this.provinceOrgCode;
            areaData.unshift(szObj);

          // console.log(areaData, '---areaData')
          // areaData 把对应的地域上的产品线挂载到当前的地域上
          for (let i = 0; i < areaData.length; i++) {
            let lineArr = [];
            for (let e of resp) {
              // console.log(e) 
              if (areaData[i].orgCode == e.orgCode) {
                let newData2 = { ...dataLine };
                newData2.orgCode = e.orgCode;
                newData2.productLineId = e.productLineId;
                newData2.shopId = e.shopId;
                newData2.shopName = e.shopName;
                newData2.goodsSkuPriceId = e.goodsSkuPriceId;
                newData2.orgName = areaData[i].orgName;
                newData2.provinceOrgName =this.provinceOrgName;  
                lineArr.push(newData2) 
              }
            }
            if (lineArr.length > 0) {
              areaData.splice(i, 1, lineArr);
            }
          }
          console.log(areaData, '---areaData111')  
          let arrFlat = this.multiarr(areaData);

          if (arrFlat == 2) {
            areaData = areaData.flat(1);//拉平1层，二维数组转1维数组
          }

          this.areaData = areaData;
          this.mapAreaData();
          // console.log(areaData, '---areaData2222') 
          // console.log(this.areaData, '---  this.areaData')
        })
        .catch((err) => { });

       
    },

    // 判断数组是几维数组
    multiarr(arr) {
      let a = 1;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] instanceof Array) {
          a++;
          arr = arr[i];
          this.multiarr(arr);
        }
      }
      return a;
    },


    mapAreaData() {
      this.areaData.map((item) => {
        // console.log(item, '--')
        // cityManager--   统一分账获取省地办 接口返回的 地办数据

        this.cityManager.map((e) => {
          //  地办初始默认选择--匹配 属于当前地办的公司
          if (item.orgCode == e.areaCode) {
            item.city_shopId = e.shopId;
            item.city_shopName = e.shopName;
            item.city_merchantNo = e.merchantNo;
          }
        });

        item.city_includeService = true; //默认true 市级没公司就选false
        let index = 0;
        // medicineManager  统一分账获取省地办 接口返回的 医药公司数据
        // shopId 取省医药公司的shopId 

        for(let k=0; k<this.medicineManager.length;k++){
          if(item.shopId==this.medicineManager[k].shopId){
            item.merchantNo = this.medicineManager[k].merchantNo;
          }
        }

        // provinceManager  统一分账获取省地办 接口返回的 省办公司数据
        if (this.provinceManager.length > 0) {
          item.serviceShopId = this.provinceManager[index].shopId;
          item.serviceShopName = this.provinceManager[index].shopName;
          item.serviceMerchantNo = this.provinceManager[index].merchantNo;
        }

        // 查询到的详情数据匹配到组织地级数据list
        if (this.deatilData.length > 0) {
          this.deatilData.map((e) => {

            if (item.orgCode == e.orgCode && item.productLineId == e.productLineId) {
              item.ledgerRulesId = e.ledgerRulesId;
              item.productLineId = e.productLineId;
              item.goodsId = e.goodsId;
              item.goodsName = e.goodsName;
              item.goodsSkuPriceId = e.goodsSkuPriceId;
              item.goodsSkuUnit = e.goodsSkuUnit;
              item.price = e.price; //销售定价
              item.status = e.status; 

              //医药公司
              item.amount = e.drugLedgerRules.amount;
              item.drug_id = e.drugLedgerRules.id;
              item.drug_ledgerRulesId = e.drugLedgerRules.ledgerRulesId;
              item.merchantNo = e.drugLedgerRules.merchantNo;
              item.shopId = e.drugLedgerRules.shopId;
              item.shopName = e.drugLedgerRules.shopName;

              //地区公司
              item.city_id = e.cityLedgerRules.id;
              item.city_ledgerRulesId = e.cityLedgerRules.ledgerRulesId;
              item.city_merchantNo = e.cityLedgerRules.merchantNo;
              item.city_amount = e.cityLedgerRules.amount;
              item.city_shopId = e.cityLedgerRules.shopId;
              item.city_shopName = e.cityLedgerRules.shopName;

              //地区需转省区公司
              item.serviceAmount = e.cityLedgerRules.serviceAmount;
              item.serviceMerchantNo = e.cityLedgerRules.serviceMerchantNo;
              item.serviceShopId = e.cityLedgerRules.serviceShopId;
              item.serviceShopName = e.cityLedgerRules.serviceShopName;
              item.dbTransferAmount = e.cityLedgerRules.dbTransferAmount;
              item.sbTransferAmount = e.cityLedgerRules.sbTransferAmount;
              item.yykTransferAmount = e.cityLedgerRules.yykTransferAmount;
              
              if( e.cityLedgerRules.serviceAmount ) {
                item.isEdit = true
              }else{
                item.isEdit = false; 
              }
            }
          });

           // 查询详情开启关闭配置 可以取一个上架了的 并且 dbTransferAmount,sbTransferAmount 有值的 list 里面的standbyEnable
            for (let item of this.deatilData) { 
              if (item.goodsSkuPriceId ){ 
                this.$parent.standbyEnable = item.cityLedgerRules.standbyEnable; 
                break
              };  
            } 

        } 
      });

      if (this.medicineManager.length == 0) {
        this.$message({
          message: `请先配置合作医药公司！`,
          type: "info",
        });
        return false;
      }
      // shopId 取省医药公司的shopId 
    },

    // 统一分账获取省地办
    getAreaCompanyFn() {
      this.loading = true;
      let params = {
        orgCode: this.provinceOrgCode, // provinceOrgCode 省区id
      };
      getAreaCompany(params).then((res) => {
        // console.log(res,'----res')
        this.kbSwitchFlag = res.kbSwitchFlag; // 康贝分流开关:0分流1不分流
        this.cityManager = res.cityManager; //市级 公司 列表
        this.provinceManager = res.provinceManager; // 省级公司列表
        this.medicineManager = res.medicineManager; //医药公司列表
        setTimeout(() => {
          this.getSelfPriceAndLedgerRuleFn();
        }, 500);
      });
    },

    // 获取分账管理列表 获取详情数据列表
    getSelfPriceAndLedgerRuleFn() {
      if (this.goodsId == "") return;
      let params = {
        goodsId: this.goodsId,
        orgCodeSet: this.orgCodeList,
      };
      getSelfPriceAndLedgerRule(params).then((res) => {
        if (res) {
          this.deatilData = res; 
        } 
        if(res.length==0){
          this.$parent.isClick =false;
          console.log('没有分账数据') 
        }else{
          this.$parent.isClick =true; 
        }
        this.initData();
      });
    }, 

    // 合并第一列单元格
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
    }, 

    objectSpanMethod({ row, column, rowIndex, columnIndex }, value) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: value.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      } else {

        //定义需要合并的列字段，有哪些列需要合并，就自定义添加字段即可
        const fields = ['orgName']
        // 当前行的数据
        const cellValue = row[column.property]
        // 判断只合并定义字段的列数据
        if (cellValue && fields.includes(column.property)) {
          const prevRow = this.areaData[rowIndex - 1] //上一行数据
          let nextRow = this.areaData[rowIndex + 1] //下一行数据
          // 当上一行的数据等于当前行数据时，当前行单元格隐藏
          if (prevRow && prevRow[column.property] === cellValue) {
            return { rowspan: 0, colspan: 0 }
          } else {
            // 反之，则循环判断若下一行数据等于当前行数据，则当前行开始进行合并单元格
            let countRowspan = 1 //用于合并计数多少单元格
            while (nextRow && nextRow[column.property] === cellValue) {
              nextRow = this.areaData[++countRowspan + rowIndex]
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        }
      }
    },
 

    // 全局应用设置价格数据
    save(from) {
      // console.log("from", from);
      // 全局设置 循环填充数据
      for (let item of this.areaData) {
        if (item.status != "PUTAWAY"||  !item.goodsSkuPriceId) continue; // 如果本条数据不是上架状态/ 或者本条数据没有sku，本条数据不做修改

        from.dbTransferAmount ? (item.dbTransferAmount = parseFloat(from.dbTransferAmount)) : (item.dbTransferAmount = ""); // 地区公司划转
        from.sbTransferAmount ? (item.sbTransferAmount = parseFloat(from.sbTransferAmount)) : (item.sbTransferAmount = ""); // 省区公司划转
        from.yykTransferAmount ? (item.yykTransferAmount = parseFloat(from.yykTransferAmount)) : (item.yykTransferAmount = ""); // 云药库划转
        
      }
      this.$forceUpdate();
    },

    validateForm(item) {
      
      if (
        (!item.dbTransferAmount || parseFloat(item.dbTransferAmount) == 0) &&
        item.city_shopName
      ) {
        this.$message({
          message: `【${item.orgName}】"地区公司划转"必须填写！`,
          type: "warning",
        });
        return false;
      } 
      return true;
    },
    // 提交数据

    validateData(type='submit',switchStatus){ 
      let orgNameTips ='';
      const groupedArr = this.groupByField(this.areaData);    
      for(let i=0;i<groupedArr.length;i++){
       const isEven= groupedArr[i].some((e)=>{ 
        // console.log(e)
          //  console.log(e.isEdit,'--e.isEdit')
          // e.cityLedgerRules.serviceAmount
          if(!e.serviceAmount){
            return true
          }else {
            return  (e.dbTransferAmount>0 ||  e.sbTransferAmount>0 )
          }
           
        })
       if(!isEven){ 
        orgNameTips += groupedArr[i][0].orgName +','; 
       } 
      }
      if(orgNameTips !=''){ 
        orgNameTips += '请设置分账'; 
        this.$confirm(orgNameTips, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => { 
           this.submiForm('submit',switchStatus)
        }).catch(() => {
                
        });
        
        return false;
      }else{
        return true;
      }
    },

     groupByField(arr) {  
        const result = [];  
        const map = new Map(); // 用于存储每个field对应的元素数组  
        
        for (const item of arr) {  
          const field = item.orgCode;  
          if (!map.has(field )) {  
            map.set(field, []); // 为新的field创建一个新数组  
          }  
          // if(item.status == 'PUTAWAY' && item.goodsSkuPriceId){
          //    map.get(field).push(item); // 将当前item添加到对应field的数组中  
          // }
          map.get(field).push(item); // 将当前item添加到对应field的数组中  
        }  
        
        // 将map的键值对转换为二维数组的形式  
        for (const [key, value] of map) {  
          result.push(value);  
        }  
        
        let newReult= result.filter(subArray => subArray.length > 0);
        return newReult ;

      }, 

    submit(type='submit',switchStatus) { 
      console.log( this.areaData,'-- this.areaData')
      // this.validateData();
 
      if(type=='submit') {
        const vaidateFlag = this.validateData(type='submit',switchStatus);
         if(!vaidateFlag) return;
      }
      this.submiForm(type,switchStatus)
    },

    submiForm(type='submit',switchStatus){  
      // console.log(type,'type')
      let params = [];
      for (let item of this.areaData) {
        // 如果本条数据没填写dbTransferAmount sbTransferAmount 此条数据不进入数据池
        if (
          (   
          !item.dbTransferAmount && 
          !item.sbTransferAmount 
          ) 
        ) {
          continue;
        }

        if (!item.city_shopName) {
          item.city_includeService = false;
        } 

        item.city_amount
          ? (item.city_amount = parseFloat(item.city_amount))
          : (item.city_amount = "");
        item.price ? (item.price = parseFloat(item.price)) : (item.price = "");
        item.amount
          ? (item.amount = parseFloat(item.amount))
          : (item.amount = "");
        item.serviceAmount
          ? (item.serviceAmount = parseFloat(item.serviceAmount))
          : (item.serviceAmount = "");

        const {
          goodsSkuUnit,
          orgName,
          orgCode,
          price,
          shopId,
          shopName,
          merchantNo,
          serviceShopId,
          serviceShopName,
          serviceAmount,
          serviceMerchantNo,
          goodsSkuPriceId,
          amount,
          productLineId,
          ledgerRulesId,
          dbTransferAmount,
          sbTransferAmount,
          setStandbyRule,
          yykTransferAmount
        } = item;
        const { goodsId, goodsName } = this;
        // 拼装给后端的数据
        let obj = {
          goodsId,
          goodsName,
          goodsSkuUnit,
          price,
        };
        obj.status = item.status;
        obj.id = item.id;
        obj.goodsSkuPriceId = goodsSkuPriceId;
        obj.productLineId = productLineId;
        obj.ledgerRulesId = ledgerRulesId;
        obj.orgCode = orgCode; //地办组织code
        obj.orgName = orgName; //地办组织名称
        obj.kbSwitchFlag = this.kbSwitchFlag;
        obj.drugLedgerRules = { shopId, shopName, merchantNo, amount };
        obj.drugLedgerRules.costType = "DETAIL";
        obj.drugLedgerRules.includeService = false;
        obj.drugLedgerRules.id = item.drug_id;
        obj.drugLedgerRules.ledgerRulesId = item.drug_ledgerRulesId;

        obj.cityLedgerRules = {
          id: item.city_id || null,
          ledgerRulesId: item.city_ledgerRulesId || null,
          amount: item.city_amount || null,
          merchantNo: item.city_merchantNo,
          shopId: item.city_shopId,
          shopName: item.city_shopName,
          includeService: item.city_shopName ? true : false,
          costType: "SERVICE",
          
        };
        obj.cityLedgerRules = {
          serviceShopId,
          serviceShopName,
          serviceAmount,
          serviceMerchantNo,
          dbTransferAmount,
          sbTransferAmount,
          yykTransferAmount,
          ...obj.cityLedgerRules,
        }; 
        obj.cityLedgerRules.standbyEnable = this.$parent.standbyEnable;
        params.push(obj);
      }
      console.log(params,'--params') 
     
      if(type=='submit'){ 
        if (params.length == 0) {
        this.$message({
          message: `请设置分账！`,
          type: "warning",
        });
        return;
      }
      // console.log(params, "params--");
      
       this.productLineAreaPrices(params); 
      }
      if(type=='open'){
        // params 保存的数据
        this.openStandByLedger(switchStatus,this.areaData)
      }
    },

    productLineAreaPrices(params) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      // 保存备用分账
      setStandbyRule(params)
        .then((res) => {

          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "error",
            });
          } else {
            this.$message({
              message: `提交成功！`,
              type: "success",
            });
          }
          setTimeout(() => {
            loading.close();
            this.init(this.provinceOrgName);
          }, 2000);

        })
        .catch((err) => {
          setTimeout(() => {
            loading.close();
          }, 2000);
        });
    },

    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss">
@import "../styles/index.scss";
.unit-input-s {
  position    : absolute;
  left        : 10px;
  z-index     : 1;
  //top         : 15px!important;
  margin-right: 10px;
}
.unitY {
  line-height: 35px;
}
</style>
